export default function isFullNameValid(name) {
  // Remove espaços extras e verifica se tem pelo menos 2 palavras
  const trimmedName = name.trim();
  const nameParts = trimmedName.split(/\s+/).filter((part) => part.length > 0);

  // Deve ter pelo menos nome e sobrenome (2 partes)
  return nameParts.length >= 2;
}
